import React from 'react';
import { useFormContext } from 'react-hook-form/dist/index.ie11';
import { Copy } from '@grubhubprod/gh-cookbook-react';
import { CookbookCheckboxWrapper } from 'src/components/CookbookCheckboxWrapper/CookbookCheckboxWrapper';
import { CustomLabelWithTooltip } from 'src/components/common/CustomLabelWithTooltip/CustomLabelWithTooltip';

export interface OrderCutoffControlProps {
  name: string;
  id: string;
}

export function OrderCutoffControl({
  name,
  id,
}: OrderCutoffControlProps): JSX.Element {
  const { control } = useFormContext();

  return (
    <CookbookCheckboxWrapper
      control={control}
      id={id}
      name={name}
      label={
        <CustomLabelWithTooltip
          color="primaryText"
          labelText="Disable meal credit ending grace period"
          tooltipInfo={
            <Copy variant="body" color="invertedPrimaryText">
              <ul>
                <li>
                  By default, meal credits have a grace period allowing order
                  placement/scheduling briefly after the credit's specified end
                  time
                </li>
                <li>
                  Select this option to strictly enforce meal credit end times
                </li>
                <li>Applies to newly created meal credits</li>
              </ul>
            </Copy>
          }
        />
      }
    />
  );
}
